var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMember(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.25 8.231A5.981 5.981 0 018 10a5.981 5.981 0 01-4.25-1.769A7.985 7.985 0 000 15v1h16v-1c0-2.855-1.5-5.354-3.75-6.769zM8 8a4 4 0 100-8 4 4 0 000 8z",
    fill: "#797584"
  })));
}

export default SvgMember;